export type SessionInfo = {
  authenticated: boolean;
  username?: string;
  agencyId?: string;
  subject?: string;
  roles: readonly string[];
  issuer?: string;
  expiresAt?: string;
};

const SIGNED_OUT: SessionInfo = { authenticated: false, roles: [] };

let current: SessionInfo = SIGNED_OUT;

export function setSessionInfo(info: SessionInfo): void {
  current = info;
}

export function clearSessionInfo(): void {
  current = SIGNED_OUT;
}

export function getSessionInfo(): SessionInfo {
  return current;
}
